// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../navbar/navbar.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-container {
  background-color: rgb(255, 255, 255) !important;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin-top: 10px;
  width: 96% !important;
}

.container-img-recipe {
  width: 100%;
  max-height: 350px;
  margin-bottom: 25px;
  padding-left: 0px !important;
  padding-right: 0px !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.recipe-content-detail {
  background-color: rgba(0, 0, 0, 0) !important;
  flex: 1 1;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  margin-bottom: 20px;
}

.recipe-left {
  background-color: rgb(255, 255, 255) !important;
  align-self: flex-start;
  font-size: 15px;
  font-family: "Lato", sans-serif !important;
  padding-bottom: 50px;
  padding-top: 10px;
}
.recipe-left h3 {
  margin-bottom: 25px;
  text-align: left;
  font-size: 30px/40px;
  font-family: "Lato", sans-serif !important;
  font-weight: 500;
  letter-spacing: 0px;
  color: #1a1919;
}
.recipe-left h5 {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 25px;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 14px/24px;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}
.recipe-left b {
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 14px/24px;
  letter-spacing: 0px;
  color: #1a1919;
  opacity: 1;
}
.recipe-left h6 {
  margin-bottom: 25px;
}
.recipe-left p {
  font-size: 16px !important;
}
.recipe-left li {
  font-size: 16px !important;
}

.recipe-right {
  background-color: rgb(255, 255, 255) !important;
  align-self: flex-start;
}

.box-print {
  background-color: rgb(255, 255, 255);
  padding: 10px;
  margin: 10px;
  border: 3px solid #1a1919;
  border-radius: 5px;
  display: flex;
  align-items: center;
  align-content: "center";
  justify-content: space-between;
  align-self: center;
  cursor: pointer;
}

.box-data {
  background-color: rgb(247, 248, 249);
  padding: 35px;
  margin: 10px;
  border-radius: 5px;
}
.box-data h3 {
  margin-bottom: 25px;
}
.box-data h5 {
  padding-right: 0 !important;
  padding-left: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  margin-bottom: 25px;
}
.box-data h6 {
  margin-bottom: 25px;
}
.box-data p {
  font-size: 16px !important;
}
.box-data li {
  font-size: 16px !important;
}

.label {
  text-align: center;
  align-self: center;
  text-transform: uppercase;
  font-size: 13px;
  font-family: "Lato", sans-serif !important;
}

@media print {
  .box-print {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/recipeContainer/recipeContainer.scss","webpack://./src/sass/layout/recipeContainer/recipeContainer.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAKA;EACE,+CAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,gBAAA;EACA,qBAAA;ACHF;;ADMA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;ACHF;;ADMA;EACE,6CAAA;EACA,SAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;ACHF;;ADMA;EACE,+CAAA;EACA,sBAAA;EACA,eAAA;EACA,0CEtCK;EFuCL,oBAAA;EACA,iBAAA;ACHF;ADKE;EACE,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0CE9CG;EF+CH,gBAAA;EACA,mBAAA;EACA,cAAA;ACHJ;ADME;EACE,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CE3DG;EF4DH,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACJJ;ADOE;EACE,gBAAA;EACA,0CEpEG;EFqEH,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACLJ;ADQE;EACE,mBAAA;ACNJ;ADSE;EACE,0BAAA;ACPJ;ADUE;EACE,0BAAA;ACRJ;;ADYA;EACE,+CAAA;EACA,sBAAA;ACTF;;ADYA;EACE,oCEvFM;EFwFN,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;ACTF;;ADYA;EACE,oCEpGoB;EFqGpB,aAAA;EACA,YAAA;EACA,kBAAA;ACTF;ADWE;EACE,mBAAA;ACTJ;ADYE;EACE,2BAAA;EACA,0BAAA;EACA,0BAAA;EACA,yBAAA;EACA,mBAAA;ACVJ;ADaE;EACE,mBAAA;ACXJ;ADcE;EACE,0BAAA;ACZJ;ADeE;EACE,0BAAA;ACbJ;;ADiBA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,0CE/IK;ADiIP;;ADiBA;EACE;IACE,wBAAA;ECdF;AACF","sourcesContent":["@import \"../../layout/navbar/navbar.css\";\n@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n \n\n.recipe-container {\n  background-color: $White !important;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  margin-top: 10px;\n  width: 96% !important;\n}\n\n.container-img-recipe {\n  width: 100%;\n  max-height: 350px;\n  margin-bottom: 25px;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n\n.recipe-content-detail {\n  background-color: $Transparent !important;\n  flex: 1;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-content: flex-start;\n  margin-bottom: 20px;\n}\n\n.recipe-left {\n  background-color: $White !important;\n  align-self: flex-start;\n  font-size: 15px;\n  font-family: $Font;\n  padding-bottom: 50px;\n  padding-top: 10px;\n\n  h3 {\n    margin-bottom: 25px;\n    text-align: left;\n    font-size: 30px/40px;\n    font-family: $Font;\n    font-weight: 500;\n    letter-spacing: 0px;\n    color: #1a1919;\n  }\n\n  h5 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    margin-bottom: 25px;\n    text-align: left;\n    font-family: $Font;\n    font-size: 14px/24px;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n  }\n\n  b {\n    text-align: left;\n    font-family: $Font;\n    font-size: 14px/24px;\n    letter-spacing: 0px;\n    color: #1a1919;\n    opacity: 1;\n  }\n\n  h6 {\n    margin-bottom: 25px;\n  }\n\n  p {\n    font-size: 16px !important;\n  }\n\n  li {\n    font-size: 16px !important;\n  }\n}\n\n.recipe-right {\n  background-color: $White !important;\n  align-self: flex-start;\n}\n\n.box-print {\n  background-color: $White;\n  padding: 10px;\n  margin: 10px;\n  border: 3px solid #1a1919;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  align-content: \"center\";\n  justify-content: space-between;\n  align-self: center;\n  cursor: pointer;\n}\n\n.box-data {\n  background-color: $MainBackgroundColor;\n  padding: 35px;\n  margin: 10px;\n  border-radius: 5px;\n\n  h3 {\n    margin-bottom: 25px;\n  }\n\n  h5 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n    margin-bottom: 25px;\n  }\n\n  h6 {\n    margin-bottom: 25px;\n  }\n\n  p {\n    font-size: 16px !important;\n  }\n\n  li {\n    font-size: 16px !important;\n  }\n}\n\n.label {\n  text-align: center;\n  align-self: center;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-family: $Font;\n}\n\n@media print {\n  .box-print {\n    display: none !important;\n  }\n}\n","@import \"../../layout/navbar/navbar.css\";\n.recipe-container {\n  background-color: rgb(255, 255, 255) !important;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  margin-top: 10px;\n  width: 96% !important;\n}\n\n.container-img-recipe {\n  width: 100%;\n  max-height: 350px;\n  margin-bottom: 25px;\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n\n.recipe-content-detail {\n  background-color: rgba(0, 0, 0, 0) !important;\n  flex: 1;\n  justify-content: space-between;\n  align-items: flex-start;\n  align-content: flex-start;\n  margin-bottom: 20px;\n}\n\n.recipe-left {\n  background-color: rgb(255, 255, 255) !important;\n  align-self: flex-start;\n  font-size: 15px;\n  font-family: \"Lato\", sans-serif !important;\n  padding-bottom: 50px;\n  padding-top: 10px;\n}\n.recipe-left h3 {\n  margin-bottom: 25px;\n  text-align: left;\n  font-size: 30px/40px;\n  font-family: \"Lato\", sans-serif !important;\n  font-weight: 500;\n  letter-spacing: 0px;\n  color: #1a1919;\n}\n.recipe-left h5 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n  margin-bottom: 25px;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px/24px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.recipe-left b {\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px/24px;\n  letter-spacing: 0px;\n  color: #1a1919;\n  opacity: 1;\n}\n.recipe-left h6 {\n  margin-bottom: 25px;\n}\n.recipe-left p {\n  font-size: 16px !important;\n}\n.recipe-left li {\n  font-size: 16px !important;\n}\n\n.recipe-right {\n  background-color: rgb(255, 255, 255) !important;\n  align-self: flex-start;\n}\n\n.box-print {\n  background-color: rgb(255, 255, 255);\n  padding: 10px;\n  margin: 10px;\n  border: 3px solid #1a1919;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  align-content: \"center\";\n  justify-content: space-between;\n  align-self: center;\n  cursor: pointer;\n}\n\n.box-data {\n  background-color: rgb(247, 248, 249);\n  padding: 35px;\n  margin: 10px;\n  border-radius: 5px;\n}\n.box-data h3 {\n  margin-bottom: 25px;\n}\n.box-data h5 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n  margin-bottom: 25px;\n}\n.box-data h6 {\n  margin-bottom: 25px;\n}\n.box-data p {\n  font-size: 16px !important;\n}\n.box-data li {\n  font-size: 16px !important;\n}\n\n.label {\n  text-align: center;\n  align-self: center;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-family: \"Lato\", sans-serif !important;\n}\n\n@media print {\n  .box-print {\n    display: none !important;\n  }\n}/*# sourceMappingURL=recipeContainer.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
